import createHttp from './request'

// 枚举
export function enumList(enumName) {
  const http = createHttp()
  return http({
    url: `/base/api/sys/enum/view?name=${enumName}`,
    method: 'get'
  })
}

/**
 * 课程分类
 * @returns {*}
 */
export function categoryLists(data) {
  const http = createHttp()
  return http({
    url: `/base/api/shop/category/list?categoryType=${data.categoryType ? data.categoryType : 1}`,
    method: 'get'
  })
}

/**
 * 题库分类
 * @returns {*}
 */
export function categoryListS(data) {
  const http = createHttp()
  return http({
    url: `/base/api/shop/category/list?categoryType=${data.categoryType ? data.categoryType : 7}`,
    method: 'get'
  })
}

/**
 * 题库二级分类
 * @param data
 * @returns {*}
 */
export function childrenLists(data) {
  const http = createHttp()
  return http({
    url: `base/api/shop/category/children`,
    method: 'post',
    data
  })
}

/**
 * 用户收藏添加
 * @param data
 * @returns {*}
 */
export function collectionUserSave(data) {
  const http = createHttp()
  return http({
    url: '/scm/auth/collection/user/save',
    method: 'post',
    data
  })
}

/**
 * 用户收藏删除
 * @param data
 * @returns {*}
 */
export function collectionUserDelete(data) {
  const http = createHttp()
  return http({
    url: '/scm/auth/collection/user/delete',
    method: 'delete',
    data
  })
}

/**
 * 获取平台信息
 * @returns {*}
 */
export function shopDataInfo(params) {
  const http = createHttp()
  return http({
    url: '/base/api/shop/website/domain',
    method: 'get',
    params
  })
}

/**
 * 获取平台协议
 * @returns {*}
 */
export function shopAgreement() {
  const http = createHttp()
  return http({
    url: '/base/api/shop/agreement',
    method: 'get'
  })
}

/**
 * 获取授权地址
 * @param data
 * @returns {*}
 */
export function getWxConfig(data) {
  const http = createHttp()
  return http({
    url: '/base/api/wx/op/get/three/authorization/url',
    method: 'post',
    data
  })
}

/**
 * 绑定授权
 * @param data
 * @returns {*}
 */
export function bindAuthInfo(data) {
  const http = createHttp()
  return http({
    url: '/base/api/wx/op/bind/authorization/info',
    method: 'post',
    data
  })
}

/**
 * 获取微信登录授权URL
 * @param data
 * @returns {*}
 */
export function getWxAuthLoginUrl(data) {
  const http = createHttp()
  return http({
    url: '/base/api/shop/user/get/wx/login/auth/url',
    method: 'post',
    data
  })
}

/**
 * 微信登录
 * @param data
 * @returns {*}
 */
export function wxLogin(data) {
  const http = createHttp()
  return http({
    url: '/base/api/shop/user/wx/authorized/login',
    method: 'post',
    data
  })
}

/**
 * 微信绑定
 * @param data
 * @returns {*}
 */
export function wxBinding(data) {
  const http = createHttp()
  return http({
    url: '/base/api/shop/user/wx/authorized/bind',
    method: 'post',
    data
  })
}

/**
 * 获取绑定微信二维码
 * @param data
 * @returns {*}
 */
export function getWxBindingQrCode(data) {
    const http = createHttp()
    return http({
      url: '/wechat/mp/bind/generateQrCode',
      method: 'get',
      requireAuth: true,
      data
    })
}

/**
 * 检查是否绑定微信状态
 * @param data
 * @returns {*}
 */

export function checkWxBindingStatus(data) {
    const http = createHttp()
    return http({
        url: '/wechat/mp/bind/checkStatus',
        method: 'post',
        requireAuth: true,
        data
    })
}

/**
 * 获取当前用户授权信息
 * @param data
 * @returns {*}
 */

export function getSysUserAuth(data) {
    const http = createHttp()
    return http({
        url: '/admin/upms/sysUser/sysUserAuth',
        method: 'post',
        requireAuth: true,
        data
    })
}

/**
 * 检查手机号是否存在
 * @param data
 * @returns {*}
 */
export function checkPhoneExist(data) {
  const http = createHttp()
  return http({
    url: '/base/api/shop/user/check/phone/exist',
    method: 'post',
    data
  })
}

/**
 * 解除微信绑定
 * @returns {*}
 */
export function dissociatedWechat() {
  const http = createHttp()
  return http({
    url: '/base/auth/shop/user/unbind/wx',
    method: 'put'
  })
}

/**
 * 绑定微信认证
 * @param data
 * @returns {*}
 */
export function bindingAuthWx(data) {
  const http = createHttp()
  return http({
    url: '/base/auth/shop/user/bind/wx',
    method: 'post',
    data
  })
}

/**
 * 获取字典列表
 * @param data
 * @returns {*}
 */
export function getSignList(data) {
  const http = createHttp()
  return http({
    url: '/base/api/sys/dict/list',
    method: 'post',
    data
  })
}

/**
 * 获取系统配置（如知情同意书、密码策略、登录策略等）
 * @param confCode 配置编码（如：informedConsent, passwordPolicy, loginPolicy）
 * @returns {*}
 */
export function getSysConf(confCode) {
  const http = createHttp()
  return http({
    url: '/admin/flow/sysConf/view',
    method: 'get',
    requireAuth: true,
    params: { confCode }
  })
}

